@if (isApplicable) {
  <div class="mt-4">
    @if (value) {
      <app-form-label>
        <app-tax-office-abbr [regimeId]="regimeId"></app-tax-office-abbr>
        Asset
      </app-form-label>

      <div class="border rounded p-2 ps-4 results">
        <div class="float-end ms-3">
          <button
            data-dd-action-name="depreciation-lookup.edit-button"
            authorizeEnable
            [authorizeRegister]="RegisterPermission.UpdateAsset"
            type="button"
            class="btn btn-outline ms-1"
            aria-label="Edit"
            (click)="openSearch()"
          >
            <i-lucide name="edit2"></i-lucide>
          </button>
          <button
            data-dd-action-name="depreciation-lookup.remove-button"
            authorizeEnable
            [authorizeRegister]="RegisterPermission.UpdateAsset"
            type="button"
            class="btn btn-outline ms-1"
            aria-label="Remove"
            (click)="clear()"
          >
            <i-lucide name="trash2"></i-lucide>
          </button>
        </div>

        <h5>{{ value.asset }}</h5>
        <p class="mb-2">
          Category:
          @for (
            category of value.categories;
            track category;
            let last = $last
          ) {
            {{ category.name }}
            @if (!last) {
              &rsaquo;
            }
          }

          @if (value.industry) {
            <br />
            Industry: {{ value.industry }}
          }
        </p>
        <div>
          Ref:
          @if (value.href) {
            <a
              data-dd-action-name="depreciation-lookup.ruling-link"
              [href]="value.href"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ value.ruling }}
              <i-lucide name="external-link"></i-lucide>
            </a>
          }
          @if (!value.href) {
            {{ value.ruling }}
          }
        </div>
      </div>
    } @else {
      @if (false) {
        <button
          data-dd-action-name="depreciation-lookup.search-button"
          authorizeEnable
          [authorizeRegister]="RegisterPermission.UpdateAsset"
          type="button"
          class="btn btn-outline"
          (click)="openSearch()"
        >
          <i-lucide name="search"></i-lucide>
          <span>
            Find the
            <app-tax-office-abbr [regimeId]="regimeId"></app-tax-office-abbr>
            Life/Rate
          </span>
        </button>
      }
    }
  </div>
}
